import request from "@/utils/request";

export default (configName, file) => {
  const fd = new FormData();
  fd.append("configName", configName);
  fd.append("file", file);
  return request.post("/commonPath/outfallReplyUpload", fd);
};
